export const getAllDevices = (resolve, reject, tokenId) => {
  let req = new Request(window.CONFIG.AWS_URL + '/getalldevices', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    }
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('getAllDevices response format error.');
      }
    } else {
      reject('getAllDevices response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const getDeviceStatus = (resolve, reject, tokenId, thingName) => {
  let req = new Request(window.CONFIG.AWS_URL + '/getdevicestatus', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      thingName: thingName
    })
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('getDeviceStatus response format error.');
      }
    } else {
      reject('getDeviceStatus response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const getQueryDevices = (resolve, reject, tokenId, condition) => {
  let req = new Request(window.CONFIG.AWS_URL + '/querydevices', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(condition)
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('getQueryDevices response format error.');
      }
    } else {
      reject('getQueryDevices response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const delDeviceInfo = (resolve, reject, tokenId, thingName) => {
  let req = new Request(window.CONFIG.AWS_URL + '/deldeviceinfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      thingName: thingName,
      from: "Dashboard"
    })
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('delDeviceInfo response format error.');
      }
    } else {
      reject('delDeviceInfo response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const editDevice = (resolve, reject, tokenId, reqBodyObj) => {
  let req = new Request(window.CONFIG.AWS_URL + '/editdevice', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('editDevice response format error.');
      }
    } else {
      reject('editDevice response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

// access device logic
export const translateDeviceStatus = (data) => {
  let statusInfo = Object.assign({}, data);
  
  // check power
  let powerInfo = '';
  switch (data.power) {
    case 0:
        powerInfo = 'Off';
        break;
    case 1:
        powerInfo = 'On';
        break;
    default:
  }
  statusInfo.power = powerInfo;

  // check light
  let lightInfo = '';
  switch (data.light) {
    case 0:
      lightInfo = 'Off';
      break;
    default:
      lightInfo = 'Light ' + data.light;
  }
  statusInfo.light = lightInfo;

  // check fan
  let fanInfo = '';
  switch (data.fan) {
    case 0:
      fanInfo = 'Off';
      break;
    default:
      fanInfo = 'Speed ' + data.fan;
  }
  statusInfo.fan = fanInfo;

  // check isOnline
  let onlineInfo = '';
  switch (data.isOnline) {
    case 0:
        onlineInfo = 'Disconnect';
        break;
    case 1:
        onlineInfo = 'Connect';
        break;
    default:
  }
  statusInfo.isOnline = onlineInfo;

  // check grease filter time
  const maxMinsGrease = data.maxGreasefilterTimer * 60;
  const remainMinsGrease = maxMinsGrease - data.usegreasefiltertime;
  let remainGrease = 0;
  if (remainMinsGrease > 0) {
      remainGrease = Math.round(remainMinsGrease / maxMinsGrease * 100);        
  } 
  statusInfo['remainGrease'] = remainGrease + '%';

  // check charcoal filter time
  const maxMinsCharcoal = data.maxCharcoalfilterTimer * 60;
  const remainMinsCharcoal = maxMinsCharcoal - data.usecharcoalfiltertime;
  let remainCharcoal = 0;
  if (remainMinsCharcoal > 0) {
      remainCharcoal = Math.round(remainMinsCharcoal / maxMinsCharcoal * 100);
  } 
  statusInfo['remainCharcoal'] = remainCharcoal + '%';

  // check steamclean
  let steamcleanInfo = '';
  switch (data.steamclean) {
    case 0:
      steamcleanInfo = 'No';
      break;
    case 1:
      steamcleanInfo = 'Yes';
      break;
    default:
  }
  statusInfo.steamclean = steamcleanInfo;

  // check airquality
  let airqualityInfo = '';
  switch (data.airquality) {
    case 0:
      airqualityInfo = 'No';
      break;
    case 1:
      airqualityInfo = 'Yes';
      break;
    default:
  }
  statusInfo.airquality = airqualityInfo;

  return statusInfo;
}